@if (isCloudflight()) {
    <a mat-button [matMenuTriggerFor]="languageMenu"
       [matTooltip]="'general.roles.choose' | translate"
       [matTooltipDisabled]="layoutService.isLargeScreen()"
    >
        <mat-icon>account_circle</mat-icon>
        <span *breakpoints="[ScreenSize.LARGE]" class="role">{{ 'general.roles.choose' | translate }}</span>
        <mat-icon iconPositionEnd>expand_more</mat-icon>
    </a>
    <mat-menu #languageMenu='matMenu' xPosition="before" yPosition="below">
        @for (entry of ROLE_NAMES | keyvalue; track $index) {
            <button mat-menu-item (click)="securityService.setRole(entry.key)">
                {{ entry.value.translationKey | translate }}
            </button>
        }
    </mat-menu>
}
